const description = 'The home for everything you need to know about using Monzo.';
const url = 'https://monzo.com/help';

const globalMetaTagsArray = [
  {
    name: 'viewport',
    content: 'width=device-width, initial-scale = 1.0, maximum-scale=1.0',
  },
  {
    httpEquiv: 'X-UA-Compatible',
    content: 'IE=edge',
  },
  { name: 'format-detection', content: 'telephone=no' },
  { name: 'description', content: description },
  { property: 'og:locale', content: 'en_GB' },
  { name: 'theme-color', content: '#14233C' },
  { property: 'og:type', content: 'website' },
  { property: 'og:url', content: url },
  { property: 'og:description', content: description },
  { property: 'og:site_name', content: 'Monzo' },
  { property: 'og:image', content: `${url}/help-og.png` },
  { property: 'twitter:card', content: 'summary_large_image' },
  { property: 'twitter:site', content: '@monzo' },
  { property: 'twitter:url', content: url },
  { property: 'twitter:description', content: description },
  { property: 'twitter:site_name', content: 'Monzo' },
  { property: 'twitter:image', content: `${url}/help-og.png` },
  { property: 'twitter:image:alt', content: 'Help with Monzo on the web' },
];

export default globalMetaTagsArray;
